import { TranslationService } from "./translation.service";
import { currencyConversion } from "./CurrencyConversion.function";

export class CurrencyHandler {
    private secondaryCurrency: string | null = null;
    private baseConversionRate: number | null = null;

    constructor(
        private templateCurrency: string,
        private localCurrency: string,
        private conversionRate: string,
        private showDoubleCurrency: boolean
    ) {
        if (!this.showDoubleCurrency) {
            return;
        }

        if (this.templateCurrency === this.localCurrency) {
            this.secondaryCurrency = 'EUR';

            this.baseConversionRate = 1/ +this.conversionRate;
        } else if (this.templateCurrency === 'EUR') {
            this.secondaryCurrency = this.localCurrency;

            this.baseConversionRate = +this.conversionRate;
        }
    }

    public get isSecondaryCurrencyDisplayed(): boolean {
        return this.showDoubleCurrency && !!this.secondaryCurrency;
    }

    public displayPrimaryCurrency(amount: number): string {
        return this.getPrimaryCurrency(amount);
    }

    public displaySecondaryCurrency(amount: number): string {
        if (!this.isSecondaryCurrencyDisplayed || !this.secondaryCurrency || !this.baseConversionRate) {
            return '';
        }
        return this.getSecondaryCurrency(amount);
    }

    private getPrimaryCurrency(amount: number) {
        return this.priceFormatter.format(amount);
    }

    private getSecondaryCurrency(amount: number) {
        return this.secondaryPriceFormatter.format(this.convertToSecondaryCurrency(amount));
    }

    private get priceFormatter(): Intl.NumberFormat {
        return new Intl.NumberFormat(`${TranslationService.getLocale()}`, {
            style: 'currency',
            currency: TranslationService.getIsoCurrencyFor(this.templateCurrency),
            currencyDisplay: 'code'
        });
    }

    private get secondaryPriceFormatter(): Intl.NumberFormat {
        if (!this.secondaryCurrency) {
            throw new Error('Secondary currency is not set');
        }

        return new Intl.NumberFormat(`${TranslationService.getLocale()}`, {
            style: 'currency',
            currency: TranslationService.getIsoCurrencyFor(this.secondaryCurrency),
            currencyDisplay: 'code'
        });
    }

    private convertToSecondaryCurrency(amount: number): number {
        return currencyConversion(amount, this.baseConversionRate!, false);
    }
}
